import { render } from "./Articoli.vue?vue&type=template&id=04467976"
import script from "./Articoli.vue?vue&type=script&lang=js"
export * from "./Articoli.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__